import React, { useRef } from 'react'
import { useGLTF, PerspectiveCamera } from '@react-three/drei'
import estructuras from '../models/estructuras.glb'

export default function Model({ ...props }) {
  const group = useRef()
  const { nodes } = useGLTF(estructuras)
  return (
    <group ref={group} {...props} dispose={null}>
      <group position={[0.01, 0, 0]} scale={0.4} rotation={[-Math.PI / 2, 0, 0]}>
        <mesh geometry={nodes.Default_150150150.geometry} material={nodes.Default_150150150.material} />
        <mesh geometry={nodes.Default_150150150_1.geometry} material={nodes.Default_150150150_1.material} />
        <mesh geometry={nodes.Default_150150150_2.geometry} material={nodes.Default_150150150_2.material} />
        <mesh geometry={nodes.Default_150150150_5.geometry} material={nodes.Default_150150150_5.material} />
        <mesh geometry={nodes.Default_150150150_4.geometry} material={nodes.Default_150150150_4.material} />
      </group>
      <PerspectiveCamera makeDefault={false} far={187.66} near={102.04} fov={39.6} position={[114.95, 15.63, 92.88]} rotation={[-0.15, 0.89, 0.11]} />
      <PerspectiveCamera makeDefault={false} far={529.12} near={468.37} fov={42.43} position={[0, 0, 500]} rotation={[0, 0, Math.PI / 2]} />
    </group>
  )
}

